jQuery(document).ready(function(){
    var form = jQuery('#service-search-form');
    jQuery('#service-search-form input:not([type="search"]):not([type="submit"])').each(function(){
        jQuery(this).change(function(){
            if(jQuery(this).attr('name') == 'target_groups[]'){
                if(jQuery('#show-hide-tags').data('all-visible') == false){
                    showLessKeywords();
                }else{
                    showMoreKeywords();
                }
            }
            services_filter_search(0);
        });
    });
    jQuery(form).submit(function(){
        services_filter_search(0);
        var navElement = jQuery('.search-page-sidebar');
        navElement.removeClass('is-active');
        navElement.attr('aria-hidden', true);
        jQuery('.mobile-search-tool-toggle').attr('aria-expanded', false);
        return false;
    });
    jQuery('.show-hide-tags-button').click(function(){
        if(jQuery(this).hasClass('more')){
            showMoreKeywords();
            jQuery('#show-hide-tags').data('all-visible', true);
        }else{
            showLessKeywords();
            jQuery('#show-hide-tags').data('all-visible', false);
        }
        return false;
    });
});

var showMoreKeywords = function(){
    var showTags = jQuery('#show-hide-tags').data('show-tags');
    var groups = jQuery('input[name="target_groups[]"]:checked').map(function(){
        return parseInt(this.value);
    }).get();
    var showCount = 0;
    jQuery('#service-search-form .tag-list li').each(function(){
        var keyword_groups = jQuery(this).data('groups');
        if((groups.length && arrayIntersection(keyword_groups, groups)) || !groups.length){
            jQuery(this).show();
            showCount++;
        }else{
            jQuery(this).hide();
            jQuery(this).find('input').prop('checked', false);
        }
    });
    jQuery('#show-hide-tags').find('.more').hide();
    if(showCount > 0 && showCount > showTags){
        jQuery('#show-hide-tags').find('.less').css('display', 'block');
    }else{
        jQuery('#show-hide-tags').find('.less').hide();
    }
}

var showLessKeywords = function(){
    var showTags = jQuery('#show-hide-tags').data('show-tags');
    var groups = jQuery('input[name="target_groups[]"]:checked').map(function(){
        return parseInt(this.value);
    }).get();
    var filteredCount = 0;
    var showCount = 0;
    var hiddenCount = 0;
    jQuery('#service-search-form .tag-list li').each(function(){
        var selected = jQuery(this).find('input').is(':checked');
        var keyword_groups = jQuery(this).data('groups');
        var filtered = arrayIntersection(keyword_groups, groups);
        if(filtered || !groups.length){
            filteredCount++;
        }
        if((showCount < showTags && ((groups.length && filtered) || !groups.length)) || ((groups.length && filtered) && selected) || !groups.length && selected){
            jQuery(this).show();
            showCount++;
        }else{
            jQuery(this).hide();
            jQuery(this).find('input').prop('checked', false);
            hiddenCount++
        }
    });
    jQuery('#show-hide-tags').find('.less').hide();
    if(hiddenCount && filteredCount > showTags){
        jQuery('#show-hide-tags').find('.more').css('display', 'block');
    }else{
        jQuery('#show-hide-tags').find('.more').hide();
    }
    var scrollPosition = jQuery(document).scrollTop();
    var mainContentTop = jQuery('#main-content').offset().top;
    var navigationHeight = jQuery('.navigation-wrapper').first().height();
    target_position = mainContentTop - navigationHeight;
    if(scrollPosition > target_position){
        jQuery('html').animate({
            scrollTop: target_position
        }, 400);
    }
}

var arrayIntersection = function(array1, array2){
    return array2.some(function (value){
        return array1.indexOf(value) >= 0;
    });
};

var services_filter_search = function(page){
    var form = jQuery('#service-search-form');
    var search = jQuery(form).find('input[name="s"]').val();
    var groups = jQuery('input[name="target_groups[]"]:checked').map(function(){
        return this.value;
    }).get();
    if(groups.length){
        jQuery('#show-all-tags').hide();
    }
    if(service_js_strings.group_category == 'ptv-target-group'){
        var target_groups = groups;
        var service_groups = service_js_strings.page_service_groups;
    }else{
        if(groups.length){
            var service_groups = groups;
        }else{
            var service_groups = service_js_strings.page_service_groups;
        }
        
    }
    var keywords = jQuery('input[name="keywords[]"]:checked').map(function(){
        return this.value;
    }).get();
    service_search_ajax(page, service_groups, search, target_groups, keywords);
}

jQuery('#load-more-button').click(function(){
    if(jQuery(this).prop('disabled') == false){
        var page = jQuery(this).data('page');
        services_filter_search(page);
    }
});

var service_search_ajax = function(page, service_groups, search, target_groups, keywords){
    var url = service_js_strings.ajax_url;
    console.log([page, service_groups, search, target_groups, keywords]);
    jQuery('#load-more-button').prop('disabled', true).addClass('loading');
    if(page == 0){
        jQuery('#load-more-button').hide();
        jQuery('#search-results-count').hide();
        services_scroll_to_results();
        jQuery('#service-search-results').html('<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>');
    }
    jQuery.ajax({
        type: 'POST',
        url: url,
        data: {
            lang: service_js_strings.lang,
            page: page,
            search: search,
            target_groups: target_groups,
            keywords: keywords,
            service_groups: service_groups
        },
        dataType: 'json',
        success: function(result){
            console.log(result);
            jQuery('#service_results_loader').remove();
            jQuery('#load-more-button').removeClass('loading');
            if(result.html){
                if(result.current_page == 1){
                    jQuery('#service-search-results').html(result.html);
                }else{
                    jQuery('#service-search-results').append(result.html);
                }
                jQuery('#load-more-button').data('page', result.current_page);
                if(result.current_page >= result.total_pages){
                    jQuery('#load-more-button').hide();
                }else{
                    jQuery('#load-more-button').prop('disabled', false);
                    jQuery('#load-more-button').show();
                }
                jQuery('#search-results-count').show().text(result.post_count+' '+service_js_strings.results_count_message);
            }else{
                jQuery('#search-results-count').hide();
                jQuery('#service-search-results').html('<div class="no-search-results">'+service_js_strings.no_results_found_message+'</div>');
            }
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) { 
            console.log("Status: " + textStatus);
            console.log(errorThrown);
        }
    });
}

var services_scroll_to_results = function(){
    var scrollPosition = jQuery(document).scrollTop();
    var navigation_height = jQuery('.navigation-wrapper').first().height();
    var results_position = jQuery('#main-content').offset().top;
    var target_position = results_position - navigation_height;
    if(scrollPosition > target_position){
        jQuery('html').animate({
            scrollTop: target_position
        }, 400);
    }
}